import { Box } from "@mui/material";
import React from "react";
import MixedText from "../../components/mixed-color-text";
import DownloadIcon from "@mui/icons-material/Download";

const Elements = () => {
  return (
    <Box>
      <h4 className="font-medium">Hi There!</h4>
      <h4 className="mt-2 font-medium">
        It's <MixedText first="Khurshida" second="Jahan (Meem)" />{" "}
      </h4>
      {/* <h5 className="mt-3 font-medium">
          I am A{" "}
          <TypeAnimation
            sequence={[
              "React Developer",
              1000,
              "Frontend Developer",
              1000,
              "Mern Stack Developer",
              1000,
              "JavaScript Developer",
              1000,
            ]}
            speed={50}
            wrapper="span"
            repeat={Infinity}
            style={{ color: variables.primaryColor }}
          />
        </h5> */}
      <h6>Jr. Frontend Software Developer</h6>
      <p className="gray-text">
        I build accessible, inclusive products and digital experiences for the
        web.
      </p>
      <div className="mt-4">
        <p className="animated-button text-black px-4 py-2 btn-bubble cursor-pointer">
          {/* <a
            className="animated-button text-black px-4 py-2 btn-bubble"
            href="https://drive.google.com/file/d/1kkOXdCzdPBsijIk8OFxhSe2_byRDwi1I/view?usp=sharing"
            data-toggle="tooltip"
            data-placement="bottom"
          /> */}
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <strong>Download Resume</strong> <DownloadIcon />
        </p>
      </div>

      <Box sx={{ mt: 5, display: "flex", flexWrap: "wrap" }}>
        <a
          className="primary-border bordered-btn rounded-full py-2 px-5 mr-3 mt-2"
          target="_blank"
          rel="noreferrer"
          href="http://codeforces.com/profile/fluffy_umbrella"
        >
          Codeforces
        </a>
        <a
          className="primary-border bordered-btn rounded-full py-2 px-5 mr-3 mt-2"
          target="_blank"
          rel="noreferrer"
          href="https://uhunt.onlinejudge.org/id/957977"
        >
          UVA OJ
        </a>
        <a
          className="primary-border bordered-btn rounded-full py-2 px-5 mt-2"
          target="_blank"
          rel="noreferrer"
          href="https://www.beecrowd.com.br/judge/en/profile/221775?origem=1"
        >
          URI OJ
        </a>
      </Box>
    </Box>
  );
};

export default Elements;
